/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Sections/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Dependents from './Dependents/index'
import Other from './Other/index'
import React from 'react'
import ResponsibleParties from './ResponsibleParties/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'



/** @type {import('Simple/types.js').View} */
export default function Sections({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Relations/Sections"
  
}) {
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
  return (<React.Fragment
>
<ResponsibleParties
  viewPath={`${viewPath}/ResponsibleParties`}
/>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 backgroundColor={dtColorsNeutral200}
 marginTop={dtSpaceLs}
 marginBottom={0}
/>
<Dependents
  viewPath={`${viewPath}/Dependents`}
/>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 marginTop={dtSpaceLs}
 marginBottom={0}
 backgroundColor={dtColorsNeutral200}
/>
<Other
  viewPath={`${viewPath}/Other`}
/>
{children}
</React.Fragment>)
}